import { render, staticRenderFns } from "./confirmacionWPP.vue?vue&type=template&id=5b46b878&scoped=true&"
import script from "./confirmacionWPP.vue?vue&type=script&lang=js&"
export * from "./confirmacionWPP.vue?vue&type=script&lang=js&"
import style0 from "./confirmacionWPP.vue?vue&type=style&index=0&id=5b46b878&lang=scss&scoped=true&"
import style1 from "./confirmacionWPP.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46b878",
  null
  
)

export default component.exports